import header from "./matterportservice-living-space.webp";
import section1 from "./matterport-1.png";
import section2 from "./punktwolke-4.png";
import section3 from "./punktwolke-3.png";
import section4 from "./punktwolke-2.png";
import section5 from "./floor-plan-cloud-point-4.png";
import section6 from "./punktwolke-1.png";
import section7 from "./matterportservice-floor-plan.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
